import React from "react";
import { fmtSignedMoney, fmtPct } from "../format";

// rankContributors — sort by |Δ| desc, collapse sub-1%-of-total rows into "other".
export function rankContributors(drivers = [], total) {
  const tot = Math.abs(total || drivers.reduce((s, d) => s + (d.deltaCost || 0), 0)) || 1;
  const sorted = [...drivers].filter((d) => Math.abs(d.deltaCost || 0) >= 0.005)
    .sort((a, b) => Math.abs(b.deltaCost) - Math.abs(a.deltaCost));
  const rows = [], tail = [];
  for (const d of sorted) {
    (Math.abs(d.deltaCost) / tot >= 0.01 ? rows : tail).push(d);
  }
  const other = { count: tail.length, delta: tail.reduce((s, d) => s + (d.deltaCost || 0), 0) };
  return { rows, other, tot };
}

// A ranked horizontal contribution chart from baseline to current — increases in
// neutral/amber, decreases in green, bar length ∝ |Δ| vs the largest mover.
export default function ContributionWaterfall({ drivers = [], max }) {
  const { rows, other } = rankContributors(drivers, max);
  const maxAbs = Math.max(1, ...rows.map((d) => Math.abs(d.deltaCost || 0)), Math.abs(other.delta || 0));
  const bar = (label, delta, share, key) => {
    const w = Math.max(2, (Math.abs(delta) / maxAbs) * 100);
    const tone = delta < 0 ? "bg-success" : "bg-chart-1";
    return (
      <div key={key} className="flex items-center gap-3 py-1.5">
        <div className="w-[38%] truncate text-[13px] text-text-2">{label}</div>
        <div className="flex-1">
          <div className="h-[10px] overflow-hidden rounded-full bg-surface-2">
            <div className={`h-full rounded-full ${tone}`} style={{ width: `${w}%` }} />
          </div>
        </div>
        <div className="w-[84px] text-right text-[13px] font-semibold tabular-nums text-text">{fmtSignedMoney(delta)}</div>
        {share != null && <div className="w-[44px] text-right text-[12px] tabular-nums text-text-3">{fmtPct(share)}</div>}
      </div>
    );
  };
  return (
    <div className="rounded-card border border-card-bd bg-card p-5">
      <div className="mb-2 text-[13px] font-semibold text-text-2">Change composition</div>
      {rows.map((d) => bar(d.label || d.key, d.deltaCost, d.sharePct, `${d.dimension}:${d.key}`))}
      {other.count > 0 && bar(`${other.count} other change${other.count === 1 ? "" : "s"}`, other.delta, null, "other")}
    </div>
  );
}
